<template>
    <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Index')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                v-model="dataId"
                @onInit="onInit"
                @onInitSuccess="onInitSuccess"
                @onRequestSuccess="onRequestSuccess"
                @onSaveSuccess="onSaveSuccess"
                :ignoreRouteParamId="true"
                getRoot="/binder-index"
                saveRoot="/binder-index"
                :formStructure="dataFormStructures.form">
            <slot slot="beforeFormButtons">
                <slot name="formButtons"></slot>
            </slot>
        </DynamicForm>
    </b-modal>
</template>

<script>
    import DynamicForm from './DynamicForm'
    export default {
        name: 'ModalBinderIndex',
        components: {
            DynamicForm
        },
        props: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(val) {
                    this.dataId = val
                },
                get() {
                    return this.dataId
                }
            },
            binderId: {
                set(val) {
                    this.dataBinderId = val
                },
                get() {
                    return this.dataBinderId
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataId: '',
                dataBinderId: '',
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'position'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'indexType'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'description',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'position',
                                type: 'select',
                                label: Core.Definition.getDefinition('Position'),
                                description: Core.Definition.getDefinition(''),
                                value: null,
                                required: true,
                                onSelect: function(value, form, fieldRefs) {}
                            },
                            {
                                id: 'indexType',
                                type: 'select',
                                label: Core.Definition.getDefinition('Type'),
                                description: Core.Definition.getDefinition(''),
                                value: null,
                                required: true,
                                onSelect: function(value, form, fieldRefs) {}
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onInit() {
                this.$refs.dynamicForm.$refs.request.addArg('binderId', this.dataBinderId)
            },
            onRequestSuccess(data, method) {
            },
            onInitSuccess(data) {
                if (data.selectOptions.position !== undefined) {
                    let position = data.selectOptions.position[data.selectOptions.position.length - 1]
                    this.$refs.dynamicForm.$refs.form.fieldRefs['position'].dataValue = position
                }
                this.$emit('onInitSuccess', data)
            },
            onSaveSuccess(data) {
                this.$emit('onSaveSuccess', data)
            }
        }
    }
</script>
